import { Section } from './section.model';

export class Page {
  PageId: number
  Sections: Section[] = []
}
